// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum CouponActionTypes {
  POST_COUPON = 'POST_COUPON',
}
